"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import { useMenuContext } from "../Menu.context.mjs";
import Menu_module_default from "../Menu.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Menu/MenuLabel/MenuLabel.tsx
const MenuLabel = factory((props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("MenuLabel", null, props);
	return /* @__PURE__ */ jsx(Box, {
		...useMenuContext().getStyles("label", {
			className,
			style,
			styles,
			classNames
		}),
		...others
	});
});
MenuLabel.classes = Menu_module_default;
MenuLabel.displayName = "@mantine/core/MenuLabel";
//#endregion
export { MenuLabel };

//# sourceMappingURL=MenuLabel.mjs.map